/* eslint-disable spire/export-styles */
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import ManageShareListModal from "@insite/content-library/Components/ManageShareListModal";
import ProductAddedToCartMessage from "@insite/content-library/Components/ProductAddedToCartMessage";
import ProductDeliveryScheduleModal from "@insite/content-library/Components/ProductDeliveryScheduleModal";
import ShareListDetailModal from "@insite/content-library/Components/ShareListDetailModal";
import ShareListModal from "@insite/content-library/Components/ShareListModal";
import reset from "@insite/client-framework/Store/Components/ProductSelector/Handlers/Reset";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import { isSwatchProduct } from "@tSurya/Common/Utilities/swatchUtils";
import addToCart from "@tSurya/Handlers/AddToCartHandler/AddToCartHandler";
import ProductSelectorVariantModal from "@tSurya/Overrides/Components/ProductSelectorVariantModal";
import * as React from "react";
import { useContext } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps {
    skipInventoryValidation?: boolean;
    skipProductPrice?: boolean;
}

const mapDispatchToProps = {
    addToCart,
    reset,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

const Modals = ({ skipInventoryValidation, addToCart, reset }: Props) => {
    const toasterContext = useContext(ToasterContext);

    // MGBW fabric swatches (swatches PLP, configurator) are added straight to cart from the
    // shared variant modal. The swatch line is flagged with mgbw_isSwatch so it surfaces in
    // the swatch mini-cart bar. Non-swatch selections return false, so the modal keeps its
    // default ProductSelector resolution flow (e.g. the cart Quick Add) unchanged.
    const handleSwatchVariantSelect = (variant: ProductModel, productInfo: ProductInfo, parentProduct?: ProductModel): false | void => {
        if (!parentProduct || !isSwatchProduct(parentProduct) || !variant?.id) {
            return false;
        }

        addToCart({
            productId: variant.id,
            qtyOrdered: 1,
            unitOfMeasure: productInfo?.unitOfMeasure ?? "",
            additionalProperties: { mgbw_isSwatch: "true" },
            onSuccess: (cartLine: CartLineModel) => {
                toasterContext.addToast({
                    body: <ProductAddedToCartMessage isQtyAdjusted={cartLine?.isQtyAdjusted} multipleProducts={false} />,
                    messageType: "success",
                });
                reset();
            },
            onError: (error: string) => {
                toasterContext.addToast({ body: error, messageType: "danger" });
                reset();
            },
        });
    };

    return (
        <>
            <AddToListModal />
            <ShareListModal />
            <ManageShareListModal />
            <ShareListDetailModal />
            <ProductSelectorVariantModal skipInventoryValidation={skipInventoryValidation} onSelect={handleSwatchVariantSelect} />
            <ProductDeliveryScheduleModal />
        </>
    );
};

export default connect(null, mapDispatchToProps)(Modals);
